import styled from "styled-components";

export const ViewerContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  &.theme-2 {
    max-width: 1240px;
  }
`;

export const DetailSection = styled.div`
  .info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    p {
      width: 100%;
      font-size: 24px;
      font-weight: 700;
      margin: 0 0 10px;
    }
    .details {
      color: #999;
      display: flex;
      gap: 20px;
      align-items: center;
      span {
        gap: 5px;
        display: flex;
        align-items: center;
      }
      svg {
        margin: 0;
      }
    }
    .action {
      display: flex;
      gap: 20px;
      button:first-child {
        position: relative;
        &::after {
          content: "";
          width: 2px;
          height: 70%;
          position: absolute;
          background: #999;
          right: -12px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    button {
      background: transparent;
      border: none;
    }
  }
  .contents {
    white-space: pre-line;
    img {
      max-width: 80%;
    }
  }
  .contents.answer {
    .date {
      display: block;
      margin-bottom: 30px;
      color: #999;
      text-align: right;
    }
    &.not {
      text-align: center;
      color: #999;
    }
  }
  .status {
    display: inline-block;
    padding: 2px 5px;
    border-radius: 5px;
    &.pending {
      color: #f1541d;
      background: #fef6f4;
    }
    &.completion {
      color: #429b8c;
      background: #e7f5f2;
    }
  }
  &.theme-0 {
    .info {
      border-bottom: 1px solid #ddd;
      padding-bottom: 20px;
      margin-bottom: 20px;
    }
    .contents {
      border-bottom: 1px solid #ddd;
      padding-bottom: 20px;
      margin-bottom: 20px;
    }
  }
  &.theme-2 {
    .info {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #d3d3d3;
      p {
        font-size: xxx-large;
        color: rgba(0, 0, 0, 0.5);
      }
    }
    .contents {
      border-bottom: 1px solid #d3d3d3;
      padding-bottom: 20px;
      margin-bottom: 20px;
    }
  }
  &.theme-4 {
    .info {
      padding: 20px;
      background: #fbfbfc;
      border-bottom: 1px solid #000;
      p {
        color: #00aeef;
      }
    }
    .contents {
      padding: 20px;
      background: #fbfbfc;
      &.answer {
        border-top: 1px solid #000;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    &.theme-2 {
      .info p {
        font-size: x-large;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .info p {
      font-size: 18px;
    }
    .nav {
      width: 70px;
      height: 30px;
    }
    &.theme-2 {
      .info p {
        font-size: large;
      }
    }
    &.theme-4 {
      .info,
      .contents {
        padding: 10px;
      }
      .info p {
        margin: 0;
      }
    }
  }
`;
